import { withTranslation } from 'react-i18next'
import TodayPicker from './TodayPicker'

export default withTranslation()(TodayPicker)
